export default {
    close: 'Close',
    dataIterator: {
      pageText: 'Viser {0} - {1} af {2} resultater',
      noResultsText: 'Ingen resultater fundet',
      loadingText: 'Indlæser data...',
    },
    dataTable: {
      itemsPerPageText: 'Rækker per side:',
      ariaLabel: {
        sortDescending: ': Sorteret faldende. Aktivér for at fjerne sortering.',
        sortAscending: ': Sorteret stigende. Aktivér for at sortere faldende.',
        sortNone: ': Ikke sorteret. Aktivér for at sortere stigende.',
      },
      sortBy: 'Sorter efter',
    },
    dataFooter: {
      itemsPerPageText: 'Resultater pr side:',
      itemsPerPageAll: 'Alle',
      nextPage: 'Næste side',
      prevPage: 'Forrige side',
      firstPage: 'Første side',
      lastPage: 'Sidste side',
    },
    datePicker: {
      itemsSelected: '{0} valgt',
    },
    noDataText: 'Ingen data fundet',
    carousel: {
      prev: 'Forrige',
      next: 'Næste',
    },
    calendar: {
      moreEvents: '{0} flere',
    },
    fileInput: {
      counter: '{0} filer',
      counterSize: '{0} filer ({1} total)',
    },
}


//////////////////
// WEBPACK FOOTER
// ./src/dk.ts
// module id = 324
// module chunks = 0